import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { billingApi } from "../api/billingApi";
import { isSubscriptionGuardBypass, TOKEN_KEY } from "../utils/jwtUtils";

const SubscriptionGuard: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [status, setStatus] = useState<"loading" | "active" | "none">(() =>
    typeof window !== "undefined" && isSubscriptionGuardBypass(localStorage.getItem(TOKEN_KEY))
      ? "active"
      : "loading"
  );
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    const token = localStorage.getItem(TOKEN_KEY);

    if (isSubscriptionGuardBypass(token)) {
      if (!cancelled) {
        setStatus("active");
      }
      return () => {
        cancelled = true;
      };
    }

    billingApi
      .getSubscription()
      .then((sub) => {
        if (cancelled) {
          return;
        }
        if (sub && (sub.status === "active" || sub.status === "trialing")) {
          setStatus("active");
        } else {
          setStatus("none");
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus("none");
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-900">
        <div className="text-gray-400">Loading...</div>
      </div>
    );
  }

  if (status === "none" && location.pathname !== "/billing") {
    return <Navigate to="/billing" replace />;
  }

  return children;
};

export default SubscriptionGuard;
